<template>
	<fieldset v-if="!unEditable || usePromo" class="coderate_fieldset" :class="{'comingSoon': $store.state.comingSoon}">
		<legend>{{ language.rateCodeLegend }}</legend>
		<input type="hidden" name="promo" id="promo" v-model="promo" data-parsley-excluded="true">
		<div class="form-row form-row--wide" :class="{'editable': !unEditable, cancellable: editMode && isCancellable}">
			<div class="form-field move-label" :class="{filled: promo}">
				<input name="coderate_display" id="coderate_display" ref="coderate" :value="promo" autocomplete="off"  @click="openDropdown" @keydown.enter.prevent="toggleDropdown" @keydown.space="openDropdown" @keyup.escape="hideDropdown" @focus="onFocus" :readonly="!editMode" :disabled="!editMode" :aria-disabled="!editMode" data-parsley-excluded="true">
				<label for="coderate_display">{{ language.rateCodeLegend }}</label>
				<a v-if="!unEditable && !!appEditLink" :href="appEditLink" role="button" class="edit-toggle" tabindex="0" :aria-label="language.editRateCode">{{ language.editRateCode }}</a>
				<a v-if="!unEditable && editable && !appEditLink" href="#" role="button" class="edit-toggle" v-bind:tabindex="editMode ? -1 : 0" @keydown.enter.prevent="enterEditMode" @click.prevent="enterEditMode" :aria-label="language.editRateCode">{{ language.editRateCode }}</a>
			</div>
			<div class="cancelButton" v-if="isCancellable && usePromo" @click="clearSelection"></div>
		</div>
	</fieldset>
</template>

<script>

export default {
	name: 'RateCode',

	props: {
		unEditable: Boolean
	},

	data: function(){
		return {
			dropDownOpen: false,
			timeout: null,
			delay: 522
		}
	},

	// mounted: function (){
	// 	this.$store.commit('setRate', this.getDefaultRate())
	// },

	computed: {
		editMode: function() {
			return this.$store.state.editMode
		},
		appEditLink: function(){
			return this.$store.state.appEditLink
		},
		editable: function() {
			return !(this.editMode && this.isCancellable)
		},
		language: function () {
			return this.$store.state.language
		},

		isCancellable: function(){
			return (this.$store.state && this.$store.state.code != this.$store.state.defaultRate) || this.usePromo
		},

		usePromo: function(){
			return !!this.$store.state.promo || false
		},

		rates: function () {
			return this.$store.state.rates
		},

		promo: {
			get() {
				if(this.usePromo) {
					return this.$store.state.promo
				}
				else if (this.$store.state.rate) {
					return this.$store.state.rate
				}
				return ''
			},
			set(value) {
				const that = this
				if(this.timeout) clearTimeout(this.timeout)
				this.timeout = setTimeout(function(){
					that.$store.dispatch('addPromo', {promo: value})
				}, this.delay)
			}
		},

		visibleRates: function () {
			return this.rates.filter(rate => !rate.invisible)
		}
	},

	methods: {

		enterEditMode(e) {
			this.$emit('edit', e)
			this.$nextTick(function(){
				this.$refs.coderate.focus()
			})
		},

		getDefaultRate() {
			const defaultRate = this.$store.state.defaultRate
			let defaultRates = this.$store.state.rates.filter(rate => rate.code == defaultRate)
			return defaultRates.shift()
		},

		toggleDropdown() {
			if(this.dropDownOpen) return this.hideDropdown()
			return this.openDropdown()
		},

		onFocus() {
			this.$emit('focus')
		},

		openDropdown() {
			this.dropDownOpen = true
			this.$emit('opened')
		},

		hideDropdown() {
			this.dropDownOpen = false
			this.$emit('closed')
		},

		selectRate(rate) {
			this.dropDownOpen = false
			this.usePromo = false
			this.promo = ''
			this.$store.dispatch('chooseRate', {rate: rate})
		},

		selectPromoText(){
			this.$refs.promo.select()
		},

		clearSelection() {
			this.$store.dispatch('chooseRate')
			this.$store.dispatch('addPromo')
			this.$nextTick(function (){
				this.isCancellable = false
				this.usePromo = false
			})
		}
	}
}
</script>